// import React, { useState } from "react";

// export const MissPunch = () => {
//   const [form, setForm] = useState({
//     date: "",
//     direction: "",
//     employee: "",
//     reason: "",
//   });
//   const [list, setList] = useState([]);

//   const employees = [
//     { id: 1, name: "Arun" },
//     { id: 2, name: "Priya" },
//     { id: 3, name: "Vijay" },
//   ]; // your employee data

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSave = () => {
//     if (!form.date || !form.direction || !form.employee) {
//       alert("Please fill required fields");
//       return;
//     }

//     setList([...list, form]);

//     setForm({
//       date: "",
//       direction: "",
//       employee: "",
//       reason: "",
//     });
//   };
//   return (
//     <div className="container mt-4">
//       <h3 className="mb-4">Missed Punch Entry</h3>

//       <div className="card p-3">
//         <div className="row g-3">
//           {/* Date */}
//           <div className="col-md-3">
//             <label className="form-label">Date</label>
//             <input
//               type="date"
//               className="form-control"
//               name="date"
//               value={form.date}
//               onChange={handleChange}
//             />
//           </div>

//           {/* Direction */}
//           <div className="col-md-3">
//             <label className="form-label">Direction</label>
//             <select
//               className="form-select"
//               name="direction"
//               value={form.direction}
//               onChange={handleChange}
//             >
//               <option value="">Select</option>
//               <option value="IN">IN</option>
//               <option value="OUT">OUT</option>
//             </select>
//           </div>

//           {/* Employee */}
//           <div className="col-md-3">
//             <label className="form-label">Employee</label>
//             <select
//               className="form-select"
//               name="employee"
//               value={form.employee}
//               onChange={handleChange}
//             >
//               <option value="">Select Employee</option>
//               {employees.map((emp) => (
//                 <option key={emp.id} value={emp.name}>
//                   {emp.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* reason */}
//           <div className="col-md-3">
//             <label className="form-label">reason</label>
//             <input
//               type="text"
//               className="form-control"
//               name="reason"
//               placeholder="Enter reason"
//               value={form.reason}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="col-12 text-end">
//             <button
//               type="button"
//               className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
//               onClick={handleSave}
//             >
//               Save
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* TABLE */}
//       <div className="mt-4">
//         <h4 className="mb-3">Missed Punch List</h4>
//         <div className="table-responsive settings-table mt-3">
//           <table className="table table-hover m-0">
//             <thead>
//               <tr className="align-middle border-top">
//                 <th>S.No</th>
//                 <th>Date</th>
//                 <th>Direction</th>
//                 <th>Employee</th>
//                 <th>reason</th>
//               </tr>
//             </thead>
//             <tbody>
//               {list.length === 0 ? (
//                 <tr>
//                   <td colSpan="5" className="text-center">
//                     No entries
//                   </td>
//                 </tr>
//               ) : (
//                 list.map((item, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{item.date}</td>
//                     <td>{item.direction}</td>
//                     <td>{item.employee}</td>
//                     <td>{item.reason}</td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//         {/* <table className="table table-bordered table-striped">
//           <thead className="table-dark">
//             <tr>
//               <th>S.No</th>
//               <th>Date</th>
//               <th>Direction</th>
//               <th>Employee</th>
//               <th>reason</th>
//             </tr>
//           </thead>
//           <tbody>
//             {list.length === 0 ? (
//               <tr>
//                 <td colSpan="5" className="text-center">
//                   No entries
//                 </td>
//               </tr>
//             ) : (
//               list.map((item, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{item.date}</td>
//                   <td>{item.direction}</td>
//                   <td>{item.employee}</td>
//                   <td>{item.reason}</td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table> */}
//       </div>
//     </div>
//   );
// };

import React, { useEffect, useState } from "react";
import api from "../../api/axios";

export const MissPunch = () => {
  const [form, setForm] = useState({
    date: "",
    time: "",
    direction: "",
    employee_id: "",
    reason: "",
  });

  const [employees, setEmployees] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const loadEmployees = async () => {
    const res = await api.get("/hrms/employees");
    setEmployees(res.data.data || []);
  };

  const loadMissPunches = async () => {
    setLoading(true);
    const res = await api.get("/hrms/missed-punch");
    setList(res.data.data || []);
    setLoading(false);
  };

  useEffect(() => {
    loadEmployees();
    loadMissPunches();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (!form.date || !form.time || !form.direction || !form.employee_id) {
      alert("Date, Time, Direction & Employee are required");
      return;
    }

    setSaving(true);
    try {
      await api.post("/hrms/missed-punch", form);
      await loadMissPunches();

      setForm({
        date: "",
        time: "",
        direction: "",
        employee_id: "",
        reason: "",
      });

      alert("Missed Punch Saved");
    } catch (err) {
      console.error(err);
      alert("Failed to save");
    }
    setSaving(false);
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Missed Punch Entry</h3>

      <div className="card p-3">
        <div className="row g-3">
          {/* Date */}
          <div className="col-md-3">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>

          {/* Time */}
          <div className="col-md-3">
            <label className="form-label">Time</label>
            <input
              type="time"
              className="form-control"
              name="time"
              value={form.time}
              onChange={handleChange}
            />
          </div>

          {/* Direction */}
          <div className="col-md-3">
            <label className="form-label">Direction</label>
            <select
              className="form-select"
              name="direction"
              value={form.direction}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="IN">IN</option>
              <option value="OUT">OUT</option>
            </select>
          </div>

          {/* Employee */}
          <div className="col-md-3">
            <label className="form-label">Employee</label>
            <select
              className="form-select"
              name="employee_id"
              value={form.employee_id}
              onChange={handleChange}
            >
              <option value="">Select Employee</option>
              {employees.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.employee_code} - {emp.first_name}
                </option>
              ))}
            </select>
          </div>

          {/* reason */}
          <div className="col-md-9">
            <label className="form-label">Reason</label>
            <input
              type="text"
              className="form-control"
              name="reason"
              placeholder="Enter Reason"
              value={form.reason}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 text-end">
            <button
              type="button"
              className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="mt-4">
        <h4 className="mb-3">Missed Punch List</h4>

        {loading ? (
          <div className="text-center py-3">Loading...</div>
        ) : (
          <div className="table-responsive settings-table mt-3">
            <table className="table table-hover m-0">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Direction</th>
                  <th>Employee</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No entries
                    </td>
                  </tr>
                ) : (
                  list.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.date}</td>
                      <td>{item.time}</td>
                      <td>{item.direction}</td>
                      <td>
                        {item.employee?.first_name +
                          " " +
                          item.employee?.last_name || "-"}
                      </td>
                      <td>{item.reason}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
